// extracted by mini-css-extract-plugin
export var fileUpload = "_g2-1";
export var modalButton = "_g2-0";